var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanknote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33594 23.834C4.33594 17.7057 4.33594 14.6416 6.23974 12.7378C8.14355 10.834 11.2077 10.834 17.3359 10.834H28.1693C34.2975 10.834 37.3617 10.834 39.2655 12.7378C41.1693 14.6416 41.1693 17.7057 41.1693 23.834C41.1693 29.9622 41.1693 33.0264 39.2655 34.9302C37.3617 36.834 34.2975 36.834 28.1693 36.834H17.3359C11.2077 36.834 8.14355 36.834 6.23974 34.9302C4.33594 33.0264 4.33594 29.9622 4.33594 23.834Z",
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1684 17.498C43.2811 17.7059 44.7032 18.1755 45.7646 19.2369C47.6684 21.1407 47.6684 24.2049 47.6684 30.3331C47.6684 36.4614 47.6684 39.5255 45.7646 41.4293C43.8608 43.3331 40.7967 43.3331 34.6684 43.3331H23.8351C17.7068 43.3331 14.6427 43.3331 12.7389 41.4293C11.6775 40.3679 11.2078 38.9458 11 36.833",
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1693 23.8327C28.1693 26.8242 25.7441 29.2493 22.7526 29.2493C19.7611 29.2493 17.3359 26.8242 17.3359 23.8327C17.3359 20.8411 19.7611 18.416 22.7526 18.416C25.7441 18.416 28.1693 20.8411 28.1693 23.8327Z",
    stroke: "#513117",
    strokeWidth: 2.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6641 28.166L34.6641 19.4993",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 28.166L10.8359 19.4993",
    stroke: "#513117",
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknote);
export default __webpack_public_path__ + "static/media/banknote.3a2d3613fdc574ea34af07ab69fd4752.svg";
export { ForwardRef as ReactComponent };